import { useAppBridge } from "@shopify/app-bridge-react";
import axios from "axios";

// intercept all requests on this axios instance
function useSetupAxiosInterceptors(onUnauthenticated) {
    const shopify = useAppBridge();

    const onRequestSuccess = (config) => {
        return shopify.idToken().then((token) => {
            config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        });
    };

    const onResponseSuccess = (response) => {
        if (response.data.successMessage) {
            shopify.toast.show(response.data.successMessage);
        }
        return response;
    };

    const onResponseError = (err) => {
        const status = err.status || err.response.status;
        console.log("sttatus :: ", status);
        if (status === 403 || status === 401) {
            console.log("onResponseError: ", err);
            onUnauthenticated();
        } else {
            shopify.toast.show(`Error: ${err.message}`, { isError: true });
        }
        return Promise.reject(err);
    };

    axios.interceptors.request.use(onRequestSuccess);
    axios.interceptors.response.use(onResponseSuccess, onResponseError);
}

// export your axios instance to use within your app
export default useSetupAxiosInterceptors;
